import IMask from "imask";
import axios from 'axios';
import 'regenerator-runtime/runtime';
export default class Forms {
    constructor() {
    }

    static serializeJSON(form) {
        const formData = new FormData(form);

        const pairs = {};

        for (const [name, value] of formData) {
            pairs[name] = value;
        }

        return JSON.stringify(pairs, null, 2);
    }

    static wrongMessages() {
        let mensagens;
        if(document.documentElement.lang === 'pt-BR') {
            mensagens = {
                messages: {
                    missingValue: {
                        checkbox: "Este campo Ã© obrigatÃ³rio.",
                        radio: "Por favor selecione um valor.",
                        select: "Por favor selecione um valor.",
                        "select-multiple":
                            "Por favor selecione pelo menos um valor.",
                        default: "Por favor preencha este campo",
                    },
                    patternMismatch: {
                        email: "Insira um endereÃ§o de e-mail corporativo vÃ¡lido.",
                        url: "Informe uma url.",
                        number: "Informe o telefone",
                        date: "Por favor utilizar o formato DD/MM/YYYY",
                        default: "Por favor, preencha o campo com conteÃºdo vÃ¡lido.",
                    },
                    outOfRange: {
                        over: "Selecione um valor que nÃ£o seja superior a {max}.",
                        under: "Selecione um valor que nÃ£o seja inferior a {min}.",
                    },
                    wrongLength: {
                        over: "Reduza este texto para nÃ£o mais que {maxLength} caracteres. VocÃƒÂª estÃ¡ usando atualmente {length} caracteres.",
                        under: "Por favor, estenda este texto para {minLength} caracteres ou mais. VocÃƒÂª estÃ¡ usando atualmente {length} caracteres.",
                    },
                },
            };
        } else {
            mensagens = {
                messages: {
                    missingValue: {
                        checkbox: "This field is required.",
                        radio: "Please select a value.",
                        select: "Please select a value.",
                        "select-multiple":
                            "Please select at least one value.",
                        default: "Please fill in this field",
                    },
                    patternMismatch: {
                        email: "Enter a valid company email address.",
                        url: "Enter a url.",
                        number: "Inform the phone",
                        date: "Please use the format DD/MM/YYYY",
                        default: "Please fill in the field with valid content.",
                    },
                    outOfRange: {
                        over: "Please select a value that is no more than {max}.",
                        under: "Please select a value that is no less than {min}.",
                    },
                    wrongLength: {
                        over: "Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.",
                        under: "Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.",
                    },
                },
            };
        }
        return mensagens;
    }

    static formDataToQueryString(formData) {
		const params = new URLSearchParams();
		for (const pair of formData.entries()) {
			params.append(pair[0], pair[1]);
		}
		return params.toString();
	}

    static maskField() {

        const phoneField = document.querySelectorAll(".telMask")
        if(phoneField) {
            phoneField.forEach(field => {
                let phoneMask = IMask(field, {
                    mask: "(00) 00000-0000",
                });
            })
        }
        
        // const dateField = document.querySelectorAll(".dateMask")
        // if(dateField) {
        //     dateField.forEach(field => {
        //         let dateMask = IMask(field, {
        //             mask: "00/00/0000",
        //         });
        //     })
        // }

        const cepField = document.querySelectorAll(".cepMask")
        if(cepField) {
            cepField.forEach(field => {
                let cepMask = IMask(field, {
                    mask: "00000-000",
                });
            })
        }
        
        const cnpjField = document.querySelectorAll(".cnpjMask")
        if(cnpjField) {
            cnpjField.forEach(field => {
                let cnpjMask = IMask(field, {
                    mask: "00.000.000/0000-00",
                });
            })
        }
        
        const cpfField = document.querySelectorAll(".cpfMask")
        if(cpfField) {
            cpfField.forEach(field => {
                let cpfMask = IMask(field, {
                    mask: "000.000.000-00",
                });
            })
        }
        
        const creditCardField = document.querySelectorAll(".creditCardMask")
        if(creditCardField) {
            creditCardField.forEach(field => {
                let creditCardMask = IMask(field, {
                    mask: "0000 0000 0000 0000",
                });
            })
        }
        
        const yearField = document.querySelectorAll(".yearMask")
        if(yearField) {
            yearField.forEach(field => {
                let yearMask = IMask(field, {
                    mask: "0000",
                });
            })
        }
        
        const cvvField = document.querySelectorAll(".cvvMask")
        if(cvvField) {
            cvvField.forEach(field => {
                let cvvMask = IMask(field, {
                    mask: "000",
                });
            })
        }





    }

    static async checkCep(input) {
        let cep = input.value.replace(/\D/g, '');
        if (cep != '') {
            let validacep = /^[0-9]{8}$/;
            //Valida o formato do CEP.
            if (validacep.test(cep)) {
                try {
                    const response = await axios.get('https://viacep.com.br/ws/' + cep + '/json/');
                    return response.data;
                } catch (error) {
                    console.log(error);
                    return null; // ou lance uma exceção se preferir
                }
            } else {
                return 'error';
            }
        }
    }
}